import icon from './orange.svg';

import type { Provider } from '../providers'

export default {
    key: 'orange',
    name: 'Orange',
    color: '#ff6600',
    icon,
    hidden: true
} satisfies Provider;
